var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { slateDtoToRaw } from '@tribeplatform/slate-kit/utils';
import { SlateContext, useSlateKitContext } from '../hooks/index.js';
import { compileSlate } from '../utils/index.js';
import { BlockRenderer } from './BlockRenderer.component.js';
export const SlateRenderer = (_a) => {
    var _b, _c, _d, _e, _f, _g, _h;
    var { slate, compiledSlate, mode = 'live', context, extraContext } = _a, restProps = __rest(_a, ["slate", "compiledSlate", "mode", "context", "extraContext"]);
    const { kit, context: slateKitContext } = useSlateKitContext();
    if (!slate) {
        return null;
    }
    const cleanedContext = Object.assign(Object.assign(Object.assign(Object.assign({}, slateKitContext), { blocksOutput: {}, mode }), context), { memberId: (_b = context.memberId) !== null && _b !== void 0 ? _b : null, collectionId: (_c = context.collectionId) !== null && _c !== void 0 ? _c : null, spaceId: (_d = context.spaceId) !== null && _d !== void 0 ? _d : null, postTypeId: (_e = context.postTypeId) !== null && _e !== void 0 ? _e : null, postId: (_f = context.postId) !== null && _f !== void 0 ? _f : null, appId: (_g = context.appId) !== null && _g !== void 0 ? _g : null, dynamicBlockKey: (_h = context.dynamicBlockKey) !== null && _h !== void 0 ? _h : null });
    compiledSlate =
        compiledSlate !== null && compiledSlate !== void 0 ? compiledSlate : compileSlate(kit, slateDtoToRaw(slate), cleanedContext);
    cleanedContext.blocksOutput = Object.values(compiledSlate.blocks).reduce((preValue, value) => (Object.assign(Object.assign({}, preValue), { [value.id]: value === null || value === void 0 ? void 0 : value.output })), {});
    const SlateWrapper = kit.loadSlateWrapper();
    const content = (React.createElement(BlockRenderer, { key: compiledSlate.rootBlock, id: compiledSlate.rootBlock }));
    return (React.createElement(SlateContext.Provider, { value: Object.assign({ slate,
            compiledSlate,
            mode, context: cleanedContext, extraContext: extraContext || { slate: {}, blocks: {} } }, restProps) }, SlateWrapper ? React.createElement(SlateWrapper, null, content) : content));
};
//# sourceMappingURL=SlateRenderer.component.js.map